import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import ActionButtons from '../../../common/table/ActionButtons';
// import { ISite, ISiteTable } from '../../../interface/Sites';
import { ColumnDef } from '@tanstack/react-table';
import { Table } from '../../../common/table/Table';
import { useFetchPositions } from '../../../../hooks/personnel/positions/useFetchPositions';
import { useDeleteTimesheet } from '../../../../hooks/personnel/personnelTimesheet/useDeleteTimesheet';
import { useDebounce } from 'use-debounce';
import Pagination from '../../../common/table/Pagination';
import Search from '../../../common/Search';
// import {useDeletePersonnel} from '../../../hooks/personnel/useDeletePersonnel'
import { getTimesheetFormData, deleteTimesheet } from '../../../../apis/personnelApi';
import { IPersonnel, ITimesheetTable } from '../../../../interface/Personnel';
import { ModalType } from '../../../../types/modal';
import { openModal } from '../../../../store/modalSlice';
import { useDispatch } from 'react-redux';
import { useModalCallback } from '../../../../contexts/ModalCallbackContext';
import MobilePagination from '../../../common/table/MobilePagination';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { toast } from 'react-toastify';
import TimesheetExcel from './timesheetExcel&pdf/TimesheetExcel';
import TimesheetPDF from './timesheetExcel&pdf/TimesheetPDF';
import { useNavigate } from 'react-router-dom';
import TimesheetForm from './TimesheetForm';
import { useFetchSchedular } from '../../../../hooks/personnel/schedular/useFetchSchedular';
import { getUserData } from "../../../../utils/utils";
import ConfirmationModal from '../../../modals/ConfirmationModal';
import { getLookUpPositions, updatePosition, getSitesByType, deleteSchedulesByProgram, addPositionToPersonnel } from '../../../../apis/personnelApi';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
interface PersonnelTableProps {
	personalId: number
	currentPersonnel: any
}
const TimeSheetTable: React.FC<PersonnelTableProps> = ({ personalId, currentPersonnel }) => {
	const { data: data, isLoading, isError, error, refetch } = useFetchPositions(personalId);

	const [isModalOpen, setModalOpen] = useState(false);
	const [selectedRow, setSelectedRow] = useState<any>(null);
	const [newPosition, setNewPosition] = useState("");
	const [positionsData, setPositionsData] = useState<any>([]);
	const [newSiteName, setNewSiteName] = useState("");
	const [newStartDate, setNewStartDate] = useState<string | null>(null);
	const [newEndDate, setNewEndDate] = useState<string | null>(null);
	const [oldSiteName, setOldSiteName] = useState("");
	const [allSiteData, setAllSiteData] = useState({
		beforeSites: [],
		afterSites: [],
		duringSites: []
	});
	const [selectedSiteData, setSelectedSiteData] = useState([]);
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [confirmationProps, setConfirmationProps] = useState({
		message: '',
		onConfirm: () => { },
		onCancel: () => { },
	});
	const [rowToDelete, setRowToDelete] = useState<any>(null);
	const [isAddMode, setIsAddMode] = useState(false);
	const [newSiteType, setNewSiteType] = useState("");
	const sortOptions = (options: any[]) => {
		if (!options) return [];
		return [...options].sort((a, b) => (a.label || '').localeCompare(b.label || '', undefined, { numeric: true }));
	};

	useEffect(() => {
		const fetchPositions = async () => {
			try {
				const response = await getLookUpPositions();

				if (response?.data?.afterPositions) {
					setPositionsData(response.data.afterPositions);
				}
				const sitesTypesData = await getSitesByType();
				if (sitesTypesData && sitesTypesData?.data) {
					setAllSiteData(sitesTypesData?.data);
				}
			} catch (error) {
				console.error("Error fetching positions:", error);
			}
		};

		fetchPositions();
	}, []);

	// const openUpdateModal = (rowData: any) => {
	// 	setSelectedRow(rowData);
	// 	setNewPosition(rowData.position); // pre-fill
	// 	setModalOpen(true);
	// };
	// const openUpdateModal = (rowData: any) => {
	// 	setSelectedRow(rowData);
	// 	// 
	// 	// newPosition should store positionId, not position text
	// 	setNewPosition(rowData.position);
	// 	setModalOpen(true);
	// };

	const openUpdateModal = (rowData: any) => {
		setSelectedRow(rowData);
		setNewPosition(rowData.position);          // Existing
		setNewSiteName(rowData.siteID);          // NEW
		setOldSiteName(rowData.siteName);
		setNewStartDate(rowData.startDate);        // NEW (yyyy-MM-dd expected)
		setNewEndDate(rowData.endDate);
		const type = rowData.siteType?.toLowerCase();
		setNewSiteType(rowData.siteType || "");
		if (type == "before") {
			setSelectedSiteData(allSiteData?.beforeSites);
		} else if (type == "after") {
			setSelectedSiteData(allSiteData?.afterSites);
		} else if (type == "during") {
			setSelectedSiteData(allSiteData?.duringSites);
		}
		setIsAddMode(false);
		setModalOpen(true);
	};

	const openAddModal = () => {
		setSelectedRow(null);
		setNewPosition("");
		setNewSiteName("");
		setOldSiteName("");
		setNewStartDate(null);
		setNewEndDate(null);
		setNewSiteType("");
		setSelectedSiteData([]);
		setIsAddMode(true);
		setModalOpen(true);
	};

	const closeModal = () => {
		setModalOpen(false);
		setSelectedRow(null);
	};

	const handleCancel = () => {
		setNewStartDate(null);
		setNewEndDate(null);
		closeModal();
	};

	const handleSavePosition = async () => {
		let selectedSiteInfo: any = selectedSiteData.find((x: any) => x.siteID == newSiteName);

		if (isAddMode) {
			let body = {
				PersonalID: personalId,
				SiteName: selectedSiteInfo?.siteName,
				SiteId: selectedSiteInfo?.siteID,
				SiteNumber: String(selectedSiteInfo?.siteNumber),
				Position: newPosition,
				SiteType: newSiteType,
				StartDate: newStartDate
					? moment(newStartDate, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss")
					: null,
				EndDate: newEndDate
					? moment(newEndDate, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss")
					: null,
			};
			await addPositionToPersonnel(body);
		} else {
			let body = {
				PersonalID: selectedRow.personID,
				OldSiteName: oldSiteName,
				NewSiteName: selectedSiteInfo?.siteName,
				NewSiteID: selectedSiteInfo?.siteID,
				NewSiteNumber: String(selectedSiteInfo?.siteNumber),
				Position: newPosition,
				ScheduleId: selectedRow.id,
				StartDate: newStartDate
					? moment(newStartDate, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss")
					: null,

				EndDate: newEndDate
					? moment(newEndDate, "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss")
					: null,
			}
			await updatePosition(body);
		}

		await refetch();
		closeModal();
	};

	const handleSiteTypeChange = (selectedOption: any) => {
		const type = selectedOption ? selectedOption.value : "";
		setNewSiteType(type);
		setNewSiteName(""); // Reset site name when type changes
		if (type.toLowerCase() === "before") {
			setSelectedSiteData(allSiteData?.beforeSites);
		} else if (type.toLowerCase() === "after") {
			setSelectedSiteData(allSiteData?.afterSites);
		} else if (type.toLowerCase() === "during") {
			setSelectedSiteData(allSiteData?.duringSites);
		} else {
			setSelectedSiteData([]);
		}
	};

	const handleDeleteClick = (rowData: any) => {
		setRowToDelete(rowData);
		setConfirmationProps({
			message: `Are you sure you want to delete the schedule for ${rowData.siteName}?`,
			onConfirm: async () => {
				try {
					const body = {
						personalID: rowData.personID,
						siteId: rowData.siteID,
						position: rowData.position
					};
					await deleteSchedulesByProgram(body);
					await refetch();
					setConfirmationOpen(false);
					setRowToDelete(null);
				} catch (error) {
					console.error('Error deleting schedule:', error);
				}
			},
			onCancel: () => {
				setConfirmationOpen(false);
				setRowToDelete(null);
			},
		});
		setConfirmationOpen(true);
	};

	const columns: ColumnDef<ITimesheetTable>[] = [
		{
			accessorKey: 'siteName',
			header: 'Site Name',
		},
		{
			accessorKey: 'distName',
			header: 'District',
			cell: ({ row }) => row.original.distName || "",
		},
		{
			accessorKey: 'distNumber',
			header: 'Budget Code',
			cell: ({ row }) => row.original.distNumber ?? "",
		},
		{
			accessorKey: 'position',
			header: 'Position',
		},
		{
			accessorKey: 'startDate',
			header: 'Effective Start Date',
			cell: ({ row }) => {
				const date = row.original.startDate;
				return date ? moment(date).format("MM-DD-YYYY") : "";
			}
		},
		{
			accessorKey: 'endDate',
			header: 'Effective End Date',
			cell: ({ row }) => {
				const date = row.original.endDate;
				return date ? moment(date).format("MM-DD-YYYY") : "";
			}
		},
		{
			id: 'action',
			header: 'Action',
			cell: ({ row }) => (
				<div className="d-flex gap-2">
					{/* <button
						className="btn btn-primary btn-sm"
						onClick={() => openUpdateModal(row.original)}
					>
						Update
					</button> */}
					{/* <button
						className="btn btn-danger btn-sm"
						onClick={() => handleDeleteClick(row.original)}
					>
						Delete
					</button> */}
					<div onClick={() => openUpdateModal(row.original)} style={{ cursor: 'pointer' }}>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M13.8001 19.5514H19.8001M4.2002 19.5514L8.56618 18.6717C8.79796 18.625 9.01077 18.5109 9.17791 18.3437L18.9516 8.56461C19.4202 8.09576 19.4199 7.33577 18.9509 6.86731L16.8805 4.79923C16.4117 4.33097 15.6521 4.33129 15.1837 4.79995L5.40896 14.58C5.24214 14.7469 5.12824 14.9593 5.0815 15.1906L4.2002 19.5514Z" stroke="#242A30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
					<div onClick={() => handleDeleteClick(row.original)} style={{ cursor: 'pointer' }}>

						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M2.3999 5.3998H21.5999M8.3999 1.7998H15.5999M9.5999 17.3998V10.1998M14.3999 17.3998V10.1998M16.1999 22.1998H7.7999C6.47442 22.1998 5.3999 21.1253 5.3999 19.7998L4.85198 6.64976C4.82358 5.96801 5.3686 5.3998 6.05094 5.3998H17.9489C18.6312 5.3998 19.1762 5.96801 19.1478 6.64976L18.5999 19.7998C18.5999 21.1253 17.5254 22.1998 16.1999 22.1998Z" stroke="#242A30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
				</div>
			),
		}
	]

	// 

	console.log('data?.data', data?.data);
	// console.log("selectedSiteData----->",selectedSiteData);

	if (isLoading) return <p>Loading...</p>;
	if (isError) return <p>{error.message}</p>;
	return (
		<>
			<section className="DashboardPage text-nowrap">
				<div className="container-fluid">
					<div className="DashboardRow  row d-flex flex-lg-row flex-md-row flex-sm-column flex-column">
						<div className="paginationDiv pt-3 mb-lg-0 mb-md-3 mb-3">
							<div className="row g-4 flex-lg-column flex-md-column flex-column-reverse">
								<div className="col-12">
									<div className="pageTable">
										<div className="pageTableInner TimeShetTable personalTab">
											<div className="d-flex justify-content-end mb-3">
												<button className="btn btn-primary" onClick={openAddModal}>Add Position</button>
											</div>
											<Table data={data?.data || []} columns={columns} ></Table>
											{/* <TimesheetForm timeSheetData={data} currentPersonnel={currentPersonnel} ></TimesheetForm> */}
											{/* <MobilePagination
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            totalPages={totalPages}
                                        /> */}
										</div>
									</div>
								</div>

							</div>
							{/* </div> */}
						</div>
					</div>
				</div>
			</section>

			{isModalOpen && (
				<div className="customModalOverlay">
					<div className="customModal">
						<h3>{isAddMode ? 'Add Position' : 'Update Timesheet'}</h3>

						{/* SITE TYPE (Only for Add Mode) */}
						{isAddMode && (
							<div className="mt-3">
								<label><b>Site Type</b></label>
								<Select
									value={[{ value: "Before", label: "Before" }, { value: "After", label: "After" }, { value: "During", label: "During" }].find(opt => opt.value === newSiteType)}
									onChange={handleSiteTypeChange}
									options={[{ value: "Before", label: "Before" }, { value: "After", label: "After" }, { value: "During", label: "During" }]}
									placeholder="Select Type"
									menuPortalTarget={document.body}
									styles={{
										menuPortal: base => ({ ...base, zIndex: 9999 }),
									}}
								/>
							</div>
						)}

						{/* SITE NAME */}
						<div className="mt-3">
							<label><b>Site Name</b></label>
							{/* <input
								type="text"
								className="form-control"
								value={newSiteName}
								onChange={(e) => setNewSiteName(e.target.value)}
							/> */}
							<Select
								value={sortOptions(selectedSiteData.map((site: any) => ({ value: site.siteID, label: site.siteName }))).find(opt => opt.value == newSiteName)}
								onChange={(selectedOption: any) => setNewSiteName(selectedOption ? selectedOption.value : "")}
								options={sortOptions(selectedSiteData.map((site: any) => ({ value: site.siteID, label: site.siteName })))}
								isSearchable={true}
								isClearable={true}
								placeholder="Select Site"
								menuPortalTarget={document.body}
								styles={{
									menuPortal: base => ({ ...base, zIndex: 9999 }),
									menu: base => ({ ...base, width: 'max-content', minWidth: '100%' })
								}}
							/>
						</div>

						{/* POSITION */}
						<div className="mt-3">
							<label><b>Position</b></label>
							<Select
								value={sortOptions(positionsData.map((pos: any) => ({ value: pos.position, label: pos.position }))).find(opt => opt.value === newPosition)}
								onChange={(selectedOption: any) => setNewPosition(selectedOption ? selectedOption.value : "")}
								options={sortOptions(positionsData.map((pos: any) => ({ value: pos.position, label: pos.position })))}
								isSearchable={true}
								isClearable={true}
								placeholder="Select Position"
								menuPortalTarget={document.body}
								styles={{
									menuPortal: base => ({ ...base, zIndex: 9999 }),
									menu: base => ({ ...base, width: 'max-content', minWidth: '100%' })
								}}
							/>
						</div>

						{/* EFFECTIVE START DATE */}
						<div className="mt-3">
							<label><b>Effective Start Date</b></label>
							<DatePicker
								selected={newStartDate ? new Date(newStartDate) : null}
								onChange={(date) => {
									if (date) {
										const formatted = moment(date).format("YYYY-MM-DD");
										setNewStartDate(formatted);
									} else {
										setNewStartDate(null);
									}
								}}
								dateFormat="MM-dd-yyyy"
								className="form-control w-100"
							/>
						</div>

						{/* EFFECTIVE END DATE */}
						<div className="mt-3">
							<label><b>Effective End Date</b></label>
							<DatePicker
								selected={newEndDate ? new Date(newEndDate) : null}
								onChange={(date) => {
									if (date) {
										const formatted = moment(date).format("YYYY-MM-DD");
										setNewEndDate(formatted);
									} else {
										setNewEndDate(null);
									}
								}}
								dateFormat="MM-dd-yyyy"
								className="form-control w-100"
							/>
						</div>

						<div className="d-flex justify-content-end mt-4 gap-2">
							<button className="btn btn-secondary" onClick={handleCancel}>Cancel</button>
							<button className="btn btn-primary" onClick={handleSavePosition}>Save</button>
						</div>
					</div>
				</div>
			)}


			<ConfirmationModal
				isOpen={confirmationOpen}
				message={confirmationProps.message}
				onConfirm={confirmationProps.onConfirm}
				onCancel={confirmationProps.onCancel}
				title="Delete Schedule"
			/>

			{/* ============================ */}
			{/*  MODAL CSS (Inline or CSS)   */}
			{/* ============================ */}
			<style>{`
                .customModalOverlay {
                    position: fixed;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(0,0,0,0.4);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }

                .customModal {
                    background: white;
                    padding: 25px;
                    border-radius: 8px;
                    width: 400px;
                    max-width: 90%;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
                }
            `}</style>
		</>
	)

}
export default TimeSheetTable